import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalLoading from './components/GlobalLoading/index';
// import { env } from 'config/app.config';

// console.log('Environment', env.REACT_APP_ENV);
// console.log('API URL', process.env.REACT_APP_URL_API);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Suspense fallback={<GlobalLoading />}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
